<form [formGroup]="form" (ngSubmit)="onSave()">
	@if ((httpError=='409')) {
	<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.appointments.shared.duplicate' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'mes.administration.calendar.dialog.create-appointment' | translate }}</h1>

	<mat-dialog-content>
		<form style="margin-top: 15px" (keydown.enter)="onSave()" [formGroup]="form">
			@if (range.controls['startTime'].invalid && range.controls['startTime'].touched) {
			<mat-error>{{ 'mes.administration.appointments.start-time.error.start-time' | translate }}</mat-error>
			} @if (range.controls['endTime'].invalid && range.controls['endTime'].touched) {
			<mat-error>{{ 'mes.administration.appointments.end-time.error.end-time' | translate }}</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label>{{ 'mes.administration.appointments.choose-date' | translate }}</mat-label>
				<mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="range">
					<input matStartDate matInput formControlName="startTime" placeholder="{{ 'mes.administration.appointments.start-time.label' | translate }}" />
					<input matEndDate matInput formControlName="endTime" placeholder="{{ 'mes.administration.appointments.end-time.label' | translate }}" />
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
				<mat-date-range-picker #dateRangePicker></mat-date-range-picker>
			</mat-form-field>

			@if (form.controls['title'].invalid && form.controls['title'].touched) {
			<mat-error>{{ ('mes.administration.appointments.title.error.' + getFirstValidationErrorName('title')) | translate }}</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'mes.administration.calendar.dialog.title.label' | translate }}</mat-label>
				<input type="text" matInput formControlName="title" cdkFocusInitial />
			</mat-form-field>

			<app-worktask-select
				[value]="form.controls['workTaskId'].value"
				(valueChange)="form.controls['workTaskId'].setValue($event)"
				[worktasks]="workTasks"
				[label]="'mes.administration.calendar.dialog.worktask.label' | translate"
				[filterPlaceholder]="'mes.administration.shift-approval.create-shift-note.worktask.filter-placeholder' | translate"
				[includeNoneOption]="true"
				[noneText]="'mes.administration.appointments.work-task.none' | translate"
				[fullWidth]="true"></app-worktask-select>

			@if (form.controls['appointmentType'].invalid && form.controls['appointmentType'].touched) {
			<mat-error>{{ 'mes.administration.appointments.appointment-type.error.required' | translate }}</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'mes.administration.calendar.dialog.appointment-type.label' | translate }}</mat-label>
				<mat-select formControlName="appointmentType">
					@for (appointmentType of appointmentTypes; track appointmentType) {
					<mat-option [value]="appointmentType.value">{{ appointmentType.text }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</form>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid || range.invalid">{{ 'mes.administration.calendar.dialog.okbtn' | translate }}</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'mes.administration.calendar.dialog.cancelbtn' | translate }}</button>
		</div>
	</div>
</form>
